module.exports = "../images/hiking@2x.png?v=7036a31";